module.exports =  {
    BULK_MESSAGING : "BULK_MESSAGING"
}
